import { render, staticRenderFns } from "./SearchResultHeader.vue?vue&type=template&id=41eaebbc&scoped=true"
import script from "./SearchResultHeader.vue?vue&type=script&lang=ts"
export * from "./SearchResultHeader.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultHeader.vue?vue&type=style&index=0&id=41eaebbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eaebbc",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/search-result-helper.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FSearchResultHeader.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports